import { useInjectReducer, useInjectSaga } from "redux-injectors";
import saga from "./saga";
import { reducer } from "./slice";

export default function UserDetailInjectors() {
  useInjectReducer({ key: "userDetail", reducer });
  useInjectSaga({ key: "userDetail", saga });
  return null;
}
